import React from "react";
import logo from "../../../assets/icons/logoEquityEdge.svg";
import BackgroundImage from "../../../assets/images/newAuthBg.png";

import "./NewAuthLeft.scss";

const NewAuthLeft = () => {
  return (
    <div className="newAuthLeftContainer">
      <div className="logoSection">
        <img
          src={logo}
          alt="EquityEdge Logo"
          height={40}
        />
      </div>
      <div className="shortIntro">
        <h3>Your Trading Journey Starts Here</h3>
        <p>Access your dashboard, manage your trading accounts, and track your performance in real-time. Stay ahead of the market with the tools and resources designed for success.</p>
      </div>
    </div>
  );
};

export default NewAuthLeft;
